var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('v-alert',{staticClass:"my-3",attrs:{"dense":"","dark":"","color":"accent"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.campos.pregunta)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }